import {ConjugationViewProps} from "../../../components/ConjugationView";
import {DutchVerb} from "../types";
import {PartOfSpeech} from "../../../../../common/types/words";

export function useDutchConjugation({word}: ConjugationViewProps) {

    if (!word.morphology) {
        return {
            hasConjugationInfo: false,
            posWithTagging: word.partOfSpeech,
        }
    }

    const verbTagger = () => {
        const info: DutchVerb = word.morphology as DutchVerb;
        return `Verb | ${info.isSeparable ? "Separable" : "Non-separable"} | ${info.uses.includes("reflexive") ? "Reflexive" : "Non-reflexive"}`;
    };

    const otherTagger = () => word.partOfSpeech;

    const posWithTagging = word.partOfSpeech === "Verb" ? verbTagger() : otherTagger();

    return {
        hasConjugationInfo: word?.partOfSpeech === PartOfSpeech.Noun || word?.partOfSpeech === PartOfSpeech.Verb || word?.partOfSpeech === PartOfSpeech.Adjective,
        posWithTagging
    }

}